import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const localesConfigPortal = {
  en: {
    portal: require('./en/portal.json'),
  },
  no: {
    portal: require('./no/portal.json'),
  },
  fr: {
    portal: require('./fr/portal.json'),
  },
  it: {
    portal: require('./it/portal.json'),
  },
  es: {
    portal: require('./es/portal.json'),
  },
  de: {
    portal: require('./de/portal.json'),
  },
  sv: {
    portal: require('./sv/portal.json'),
  },
  da: {
    portal: require('./da/portal.json'),
  },
  fi: {
    portal: require('./fi/portal.json'),
  },
  nl: {
    portal: require('./nl/portal.json'),
  },
  'fr-be': {
    portal: require('./fr-be/portal.json'),
  },
  'nl-be': {
    portal: require('./nl-be/portal.json'),
  },
}

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: localesConfigPortal,
    fallbackLng: 'en',
    order: ['localStorage', 'navigator', 'htmlTag'],
    ns: ['portal'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: { useSuspense: false },
  })

export default i18n
